import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AttachmentModel } from '../../shared/model/attachment.model';
import { FileUpload } from 'primeng/primeng';
import { AttachmentService } from '../../shared/service/attachment.service';
import { ChecklistModel } from '../../shared/model/checklist.model';

@Component({
  selector: 'app-attachment-modal',
  templateUrl: './attachment-modal.component.html',
  styleUrls: ['./attachment-modal.component.css']
})
export class AttachmentModalComponent implements OnInit {
  @Output() saved = new EventEmitter<void>();
  @ViewChild('fileUpload') fileUpload: FileUpload;

  display: boolean;
  parent: string;
  parentId: number;
  attachment: AttachmentModel = new AttachmentModel();

  constructor(private attachmentService: AttachmentService) { }

  ngOnInit() { }

  onFileSelect(event) {
    this.attachment.file = event.files[0] ? event.files[0] : null;

    if(this.attachment.file) {
      this.attachment.name = this.attachment.name ? this.attachment.name : this.attachment.file.name;
    }

    this.fileUpload.clear();
  }

  save() {
    let record;
    if(!this.attachment.id){
      
      const {name, file} = this.attachment;
      record = new FormData();
  
      record.append('name', name);
      record.append('parent', this.parent);
      record.append('id', this.parentId);
      record.append('attachment', file);
      
    }else {
      record = new AttachmentModel();
      record.id = this.attachment.id;
      record.name = this.attachment.name;
    }

    return this.attachmentService.save(record).subscribe(result => {
      this.saved.emit();
      this.closeModal();
    });
  }

  closeModal() {
    this.attachment = new AttachmentModel();
    console.log(this.attachment);
    
    this.display = false;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/attachment-list/attachment-modal/attachment-modal.component.ts